import './style.scss';

const ExperiencePage = () => (
  <section className="experience">
    <div className="experience__row">
      <div className="experience__section">
        <p className="experience__title">Experience</p>

        <div className="experience__block">
          <p className="experience__block-title">Finance</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option">Personal Finance</li>
            <li className="experience__block-option">Wealth Management</li>
            <li className="experience__block-option">Venture Capital</li>
            <li className="experience__block-option">Startup Funding</li>
          </ul>
        </div>
        
        <div className="experience__block">
          <p className="experience__block-title">Business</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option">Corporate Advisory and Strategy</li>
            <li className="experience__block-option">Business Development and Partnerships</li>
            <li className="experience__block-option">Marketing</li>
            <li className="experience__block-option">User Experience and Design</li>

          </ul>
        </div>
      </div>
      <div className="experience__section">
        <p className="experience__title">Career</p>
        <div className="experience__block">
          <p className="experience__block-title">RobotMoney</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option experience__block-option_no-circle">Founder and CEO:&nbsp;&nbsp;May 2026 to Present</li>
          </ul>
        </div>
        <div className="experience__block">
          <p className="experience__block-title">Majlis Capital</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option experience__block-option_no-circle">Founder and General Partner:&nbsp;&nbsp;Sep 2026 to Present</li>
          </ul>
        </div>
        <div className="experience__block">
          <p className="experience__block-title">Orange Labs</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option experience__block-option_no-circle">Founder and CEO:&nbsp;&nbsp;Aug 2017 to Dec 2025</li>
          </ul>
        </div>
        <div className="experience__block">
          <p className="experience__block-title">Microsoft Corporation</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option">US Partner Services Director:&nbsp;&nbsp;Feb 2008 to Jan 2015</li>
            <li className="experience__block-option">Resource Manager:&nbsp;&nbsp;Mar 2006 to Jan 2008</li>
            <li className="experience__block-option">Technical Account Manager:&nbsp;&nbsp;Jul 1999 to Feb 2006</li>
            <li className="experience__block-option">University Consultant:&nbsp;&nbsp;Jul 1998 to Jul 1999</li>
          </ul>
        </div>
        <div className="experience__block">
          <p className="experience__block-title">Contributing Author</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option">Entrepreneur Magazine</li>
            <li className="experience__block-option">Nasdaq</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="experience__row">
      <div className="experience__section">
        <p className="experience__title">Education</p>
        <div className="experience__block">
          <p className="experience__block-title">Indiana University – Kelley School of Business</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option experience__block-option_no-circle">Microsoft Business Management Certificate Program</li>
          </ul>
        </div>
        <div className="experience__block">
          <p className="experience__block-title">Southern Methodist University – Cox School of Business</p>
          <ul className="experience__block-option-list">
            <li className="experience__block-option experience__block-option_no-circle">Bachelors of Business Administration degree in Management Information Systems</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="experience__row">
      <div className="experience__section">
        <p className="experience__title experience__title_certificate">Certifications</p>
        <div className="experience__block">
          <ul className="experience__block-option-list">
            <li className="experience__block-option">Certified Bitcoin Professional</li>
            <li className="experience__block-option">Microsoft Windows 2003 Certification</li>
            <li className="experience__block-option">Microsoft Certified Systems Administrator</li>
            <li className="experience__block-option">Project Management Basics for Team Leads</li>
            <li className="experience__block-option">FKA Instructional Techniques</li>
            <li className="experience__block-option">Microsoft Windows 2000 Certification</li>
            <li className="experience__block-option">Information Technology Infrastructure Library Foundation</li>
            <li className="experience__block-option">Microsoft Windows NT4 Certification</li>
            <li className="experience__block-option">Microsoft Certified Systems Engineer</li>
            <li className="experience__block-option">Microsoft Certified Professional</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default ExperiencePage;
